module.exports = __webpack_public_path__ + "static/media/twitter.358e54fd.svg";